module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_library.js
// module id = 90
// module chunks = 168707334958949